export const SHIPPING=200
export const TAXES=0.00
export const ITEMS_PER_PAGE=10